import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const FractionCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [num1, setNum1] = useState('1');
  const [den1, setDen1] = useState('2');
  const [num2, setNum2] = useState('1');
  const [den2, setDen2] = useState('4');
  const [operation, setOperation] = useState('add');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const n1 = parseInt(num1) || 0;
    const d1 = parseInt(den1) || 1;
    const n2 = parseInt(num2) || 0;
    const d2 = parseInt(den2) || 1;

    let resultNum = 0;
    let resultDen = 1;

    switch (operation) {
      case 'add':
        resultNum = n1 * d2 + n2 * d1;
        resultDen = d1 * d2;
        break;
      case 'subtract':
        resultNum = n1 * d2 - n2 * d1;
        resultDen = d1 * d2;
        break;
      case 'multiply':
        resultNum = n1 * n2;
        resultDen = d1 * d2;
        break;
      case 'divide':
        resultNum = n1 * d2;
        resultDen = d1 * n2;
        break;
    }

    // Simplificar fração
    const gcd = (a: number, b: number): number => {
      return b === 0 ? Math.abs(a) : gcd(b, a % b);
    };

    const divisor = gcd(resultNum, resultDen);
    const res = {
      num: resultNum / divisor,
      den: resultDen / divisor,
      decimal: resultNum / resultDen
    };
    setResultState(res);

    onResultChange([
      { label: 'Expressão', value: `${num1}/${den1} ${operation === 'add' ? '+' : operation === 'subtract' ? '-' : operation === 'multiply' ? '×' : '÷'} ${num2}/${den2}` },
      { label: 'Resultado (Fração)', value: `${res.num}/${res.den}` },
      { label: 'Resultado (Decimal)', value: res.decimal.toFixed(4) }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div>
            <FormField
              label="Numerador 1"
              placeholder="Ex: 1"
              value={num1}
              onChange={setNum1}
              required
            />
            <FormField
              label="Denominador 1"
              placeholder="Ex: 2"
              value={den1}
              onChange={setDen1}
              required
            />
          </div>

          <div className="flex items-center justify-center">
            <FormField
              label="Operação"
              value={operation}
              onChange={setOperation}
              type="select"
              required
              options={[
                { value: 'add', label: '+' },
                { value: 'subtract', label: '-' },
                { value: 'multiply', label: '×' },
                { value: 'divide', label: '÷' }
              ]}
            />
          </div>

          <div>
            <FormField
              label="Numerador 2"
              placeholder="Ex: 1"
              value={num2}
              onChange={setNum2}
              required
            />
            <FormField
              label="Denominador 2"
              placeholder="Ex: 4"
              value={den2}
              onChange={setDen2}
              required
            />
          </div>
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Frações
          </button>
        </div>

        {resultState && (
          <ResultCard
            title="Resultado"
            value={`${resultState.num}/${resultState.den}`}
            description={`Decimal: ${resultState.decimal.toFixed(4)}`}
            color="purple"
          />
        )}
      </div>

      <EducationalBlock
        title="Operações com Frações"
        tips={[
          'Adição: (a/b) + (c/d) = (ad + bc) / bd',
          'Subtração: (a/b) - (c/d) = (ad - bc) / bd',
          'Multiplicação: (a/b) × (c/d) = ac / bd',
          'Divisão: (a/b) ÷ (c/d) = ad / bc'
        ]}
      />
    </div>
  );
};

export default FractionCalculator;
